import axios from 'axios';

const api = axios.create({
  withCredentials: true, // 세션 쿠키 전송 (Spring Security)
});

// 401 응답 시 admin 로그인 페이지로 리다이렉트
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isAdminPath = window.location.pathname.startsWith('/admin');
      const isLoginPage = window.location.pathname === '/admin/login';
      if (isAdminPath && !isLoginPage) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
